export default "__VITE_ASSET__CBTOvQH4__"